<p-table [value]="products" styleClass="p-datatable-gridlines">
  <ng-template pTemplate="header">
    <tr>
      <th colspan="2">Product</th>
      <th>Units</th>
      <th *ngIf="canEdit">
        <a href="javascript:void(0)" (click)="displayAddProductDialog = true"
          >Add Product</a
        >
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-product>
    <tr>
      <td>
        <img
          *ngIf="product && (product?.product?.images)[0]?.sizes.length"
          [src]="product.product.images[0].sizes[0].url"
          style="max-height: 80px"
          alt="{{ product.product.name }}"
        />
      </td>
      <td>
        {{ product.product.name }}
      </td>
      <td>
        {{ product.units }}
      </td>
      <td *ngIf="canEdit">
        <a href="javascript:void(0)" (click)="removeProduct(product.productId)"
          >Remove</a
        >
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary" *ngIf="canEdit">
    <p *ngIf="!products || !products.length">
      There are no products added to the transfer yet...
    </p>
    <button
      class="mt-3"
      pButton
      type="button"
      label="Add Product"
      (click)="displayAddProductDialog = true"
    ></button>
  </ng-template>
</p-table>

<p-dialog
  [(visible)]="displayAddProductDialog"
  [style]="{ width: '450px' }"
  header="Add Product"
  [modal]="true"
>
  <div class="grid formgrid">
    <form [formGroup]="productFormGroup">
      <div class="field col-12">
        <label> Product: </label>
        <span class="p-fluid">
          <p-autoComplete
            id="product"
            placeholder="Start typing to search products..."
            [forceSelection]="true"
            [suggestions]="productSearchResults"
            (completeMethod)="searchProduct($event)"
            field="name"
            value="id"
            formControlName="product"
          ></p-autoComplete>
        </span>
      </div>

      <p-messages severity="warn" *ngIf="productSearchResults?.length === 0">
        <ng-template pTemplate>
          <span class="custom-message"
            >No results found, try a different word.</span
          >
        </ng-template>
      </p-messages>

      <div class="field col-12" *ngIf="productSearchResults?.length > 0">
        <label> Units: </label>
        <input
          pInputText
          type="number"
          min="1"
          step="1"
          required
          formControlName="units"
          class="w-full"
        />
      </div>
    </form>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      pRipple
      label="Cancel"
      icon="pi pi-times"
      class="p-button-text"
      (click)="this.displayAddProductDialog = false"
    ></button>
    <button
      pButton
      pRipple
      label="Save"
      icon="pi pi-check"
      class="p-button-text"
      [disabled]="!productFormGroup"
      (click)="addProduct()"
    ></button>
  </ng-template>
</p-dialog>
